// the property items to show for the schema object in Response and Request Body
export const initialItemsToShow = 10;

// JS pages with sidebar
export const pagesToShowSidebar = ['changelog'];
